import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {CardDeck, DeckType} from '../../shared/card-deck';
import {RecommendedGameDesign} from '../../design-recommender/shared/recommended-game-design';
import {GameDesign} from '../../design-recommender/shared/game-design';
import {UserValidation} from '../../shared/user-validation';
import {AttributionType} from '../../deck-explorer/shared/attribution-types.enum';
import {CardStoreService} from '../../shared/card-store.service';
import {RecommendationService} from '../../design-recommender/shared/recommendation.service';
import {GameDesignService} from '../../design-recommender/shared/game-design.service';
import {ActivatedRoute} from '@angular/router';
import {AttributionService} from '../../deck-explorer/shared/attribution.service';
import {MatSidenav} from '@angular/material/sidenav';
import {Platform} from '@angular/cdk/platform';
import { CardSelectionService } from '../shared/card-selection.service';


@Component({
  selector: 'em-default-decks',
  templateUrl: './default-decks.component.html',
  styleUrls: ['./default-decks.component.css']
})
export class DefaultDecksComponent implements OnInit {


  cardDeck$: Observable<CardDeck>;

  @Input() cardDeckIdSelection: number;

  @Input() searchForm;
  @Input() deckType;
  @Input() rightSidenav: MatSidenav;

  @Output() deleteSearchResults = new EventEmitter<void>();

  recommendedGameDesign: RecommendedGameDesign;
  gameDesign: GameDesign;

  userValidation$: Observable<UserValidation>;

  attribution: AttributionType;
  subAttribution: AttributionType;
  recommendationSorting: boolean;

  dragStartDelay: number;

  hoveredCardId: number | null = null;
  selectedCardId: number | null = null;

  private previewTimeout: any;

  constructor(
    private cs: CardStoreService,
    private rs: RecommendationService,
    private gs: GameDesignService,
    private route: ActivatedRoute,
    private as: AttributionService,
    private platform: Platform,
    private cse: CardSelectionService
  ) {
    this.cs.getUserLoginListener().subscribe(b => {
      if (b === undefined) {
        this.recommendedGameDesign = undefined;
        this.gameDesign = undefined;
        this.cardDeck$ = undefined;
        this.userValidation$ = undefined;
      }
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(
      paramMap => {
        let cardDeckId;
        if (this.cardDeckIdSelection) {
          cardDeckId = this.cardDeckIdSelection;
        } else {
          cardDeckId = Number(paramMap.get('carddeckid'));
        }
        this.cardDeck$ = this.cs.getCardDeck(cardDeckId);
        this.cardDeck$.subscribe(deck => {
          this.gs.initGameDesign(deck.id, deck.type);

          this.gameDesign = this.gs.getGameDesign();
          this.gs.getGameDesignBehaviorSubject().subscribe(gameDesign => {
            this.gameDesign = gameDesign;
          });

          // Changes in the game design should cause new recommendations
          if (!this.rs.checkIfRecommendationRequestIsPossible()) {
            this.rs.setGameDesignBehaviorSubject(this.gs.getGameDesignBehaviorSubject());
          }

          // Changes in the recommendation should change the recommended game design
          this.rs.getRecommendationBehaviorSubject().subscribe(recommendedGameDesign => {
            if (this.rs.hasRecommendation()) {
              this.recommendedGameDesign = recommendedGameDesign;
            } else {
              this.recommendedGameDesign = null;
            }
          });

          this.rs.getRecommendationSortingBehaviorSubject().subscribe(sort => {
            this.recommendationSorting = sort;
          });
        });
      }
    );
    this.as.getAttributionBehaviorSubject().subscribe(
      attributionType => {
        this.attribution = attributionType;
      }
    );
    this.as.getSubAttributionBehaviorSubject().subscribe(
      attributionType => {
        this.subAttribution = attributionType;
      }
    );
    this.cs.getUserLoginListener().subscribe(b => {
      this.userValidation$ = b;
    });
    // Ensure that the GameDesign is initizalized with ALL cardDecks
    // and not only with the one derived from the routing param
    this.userValidation$.subscribe(userValidation => {
      for (const cardDeck of userValidation.carddecks) {
        this.gs.initGameDesign(cardDeck.id, cardDeck.type);
      }
    });
    if (this.platform.IOS || this.platform.ANDROID) {
      // Set a longer drag delay for touch/mobile devices
      this.dragStartDelay = 200;
    } else {
      this.dragStartDelay = 0;
    }
  }

  deleteResults() {
    this.deleteSearchResults.emit();
  }

  selectCard(id: number, deckId: number, deckType: DeckType): void {
   this.selectedCardId = id;
   this.cse.clear();
   setTimeout(() => {
    this.cse.selectCard({ id, cardDeckId: deckId, cardDeckType: deckType });
   }, 0);
  }

  clearSelection(): void {
   this.selectedCardId = null;
  }

  cancelPreview(): void {
    clearTimeout(this.previewTimeout);
    this.cse.clear();
  }

}
